module.exports = __webpack_public_path__ + "img/0xbtc.ca90430d.svg";